const rootArea = "/feedback";

export const feedbackGlob = () => ({
	read: `${rootArea}/read`, 
	vesl: {
		read: `${rootArea}/vesl/read`,
		phoneNumber: { read: `${rootArea}/vesl/phoneNumber/read` },
		email: { read: `${rootArea}/vesl/email/read` }
	},
	agency: {
		read: `${rootArea}/agency/read`,
		phoneNumber: { read: `${rootArea}/agency/phoneNumber/read` },
		email: { read: `${rootArea}/agency/email/read` },
		markdown: { read: `${rootArea}/agency/markdown/read` }
	},
	remoteSupport: { read: `${rootArea}/remoteSupport/read` }
});
